import React from "react";
import { Skeleton } from "primereact/skeleton";
import C from "classnames";

import { ContentCardProps } from "./contentCardTypes";

import S from "./PathCard/PathCard.module.scss";

export const ContentCardSkeleton: React.FC<Partial<ContentCardProps>> = ({
  cardSize = "large",
  showActivated = false,
}) => {
  const isSmallCard = cardSize === "small";

  return (
    <div
      className={C(S.pathCardWrapper, isSmallCard ? S.smallCard : S.largeCard, "bg-elevation-1")}
    >
      <div className={C(S.pathCardContainer, isSmallCard ? S.smallCardContainer : S.largeCard)}>
        <div className="grid gap-1">
          {/* Tag */}
          <div className="mt-2">
            <Skeleton width="60px" height="26px" />
          </div>
          {/* Title */}
          <Skeleton width="250px" height={isSmallCard ? "28px" : "32px"} />
          {/* Stats */}
          <div className="mt-2">
            <div className="flex items-center gap-2 mb-8">
              <Skeleton width="60px" height="14px" />
              <Skeleton width="60px" height="14px" />
            </div>
            {/* Button skeleton at the bottom */}
            <div>
              <Skeleton width="120px" height="42px" />
            </div>
          </div>
        </div>
        {/* absolute on the top right */}
        {showActivated && (
          <div className="absolute top-4 right-4">
            <Skeleton width="16px" height="16px" />
          </div>
        )}
      </div>
    </div>
  );
};
